import React from 'react';

const MessageInput = ({ userMessage, setUserMessage, onSendMessage, isSending }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !isSending) {
      onSendMessage();
      e.preventDefault();
    }
  };

  return (
    <div className="message-input-container">
      <textarea
        className="message-input"
        value={userMessage}
        onChange={(e) => setUserMessage(e.target.value)}
        onKeyDown={handleKeyPress}
        placeholder="Write your reasoning here"
        rows={5}
        onCopy={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        onCut={(e) => e.preventDefault()}
      />
      <button className="send-button" onClick={onSendMessage} disabled={isSending}>
        {isSending ? <span className="loading-spinner"></span> : "Send"}
      </button>
    </div>
  );
};

export default MessageInput;
